const Frontend = {
    title: "Frontend",
    icons: [
        { icon: "logos:html-5", name: "HTML5" },
        { icon: "logos:css-3", name: "CSS3" },
        { icon: "devicon:bootstrap", name: "Bootstrap" },
        { icon: "logos:javascript", name: "JavaScript" },
        { icon: "logos:tailwindcss-icon", name: "Tailwind" },
        {icon: "catppuccin:jinja", name: "Jinja" },
        { icon: "logos:material-ui", name: "Material UI" },
        { icon: "logos:react", name: "React" },
        { icon: "logos:vue", name: "Vue" },
    ]
};
export default Frontend;